import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@eatclubcode/ec-component-library';

/**
 * A better primary button. This one is yellow
 */
export const PrimaryButton = ({ children = null, style, ...other }) => (
  <Button
    type='primary'
    style={{
      ...style,
      button: {
        backgroundColor: '#FAD14C',
        color: '#313131',
        padding: '8px 24px 10px 24px',
        width: 'fit-content',
        minWidth: '150px',
        height: '44px',
        border: '1px solid black',
        fontWeight: '400',
        lineHeight: 'unset',
        ...style?.button,
      },
      text: {
        verticalAlign: 'middle',
        ...style?.text,
      },
    }}
    {...other}
  >
    {children}
  </Button>
);

PrimaryButton.propTypes = {
  children: PropTypes.node,
};
